import { supabaseClient } from '../config/supabase';

export const STAFF_APPS = [
    {
        id: 'command_center', label: 'Central Command', help: 'Manage business operations in Central Command.',
        endpoint: 'team-invite',
        request: ({ saved, record, selection }) => ({
            action: 'invite', staffId: saved.staff_id, email: record.email,
            role: selection.role, entityIds: selection.entity_ids
        })
    },
    {
        id: 'driver_app', label: 'Driver App', help: 'Driver onboarding and trip assignments.',
        endpoint: 'driver-application-auth',
        request: ({ saved }) => ({
            action: 'provision_login', applicantId: saved.applicant_id
        })
    }
];

export function staffAppSelection(member = {}) {
    return {
        ...Object.fromEntries(STAFF_APPS.map((app) => [app.id, { enabled: false }])),
        command_center: {
            enabled: member.command_center_enabled ?? Boolean(member.command_center_role),
            role: ['user', 'assignable_admin'].includes(member.command_center_role)
                ? member.command_center_role : member.command_center_role ? 'admin' : 'user',
            preset_id: member.command_center_preset_id || '',
            entity_ids: member.command_center_entity_ids || []
        },
        driver_app: {
            enabled: member.driver_app_enabled ?? Boolean(member.driver_id),
            onboarding_mode: 'guided', step_ids: [], attestation: false, note: ''
        }
    };
}

export async function provisionStaffApps(selection, saved, record) {
    for (const app of STAFF_APPS) {
        if (!selection[app.id]?.enabled) continue;
        // The team invitation binds the same login to the saved staff and driver.
        if (app.id === 'driver_app' && selection.command_center?.enabled) continue;
        if (app.id === 'driver_app' && saved.driver_login_ready) continue;
        const { data, error } = await supabaseClient.functions.invoke(app.endpoint, {
            body: app.request({ saved, record, selection: selection[app.id] })
        });
        if (error || data?.error || data?.ok === false) {
            throw new Error(`${app.label}: ${data?.error || error?.message || 'Access could not be provisioned.'} The staff record is saved. Retry without creating another person.`);
        }
    }
}
